(() => {
  const availabilityParameter = 'filter.v.availability';
  const showAllSessionKey = 'sp-show-out-of-stock';

  const getShowAllPreference = () => {
    try {
      return window.sessionStorage.getItem(showAllSessionKey) === '1';
    } catch {
      return false;
    }
  };

  const setShowAllPreference = (showAll) => {
    try {
      if (showAll) window.sessionStorage.setItem(showAllSessionKey, '1');
      else window.sessionStorage.removeItem(showAllSessionKey);
    } catch {
      // Filtering still works if storage is unavailable; only session persistence is skipped.
    }
  };

  if (window.__spAvailabilityDefaultInitialized) return;
  window.__spAvailabilityDefaultInitialized = true;

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== availabilityParameter) return;
      setShowAllPreference(!input.checked);
    },
    true
  );

  const targetURL = new URL(window.location.href);
  if (!targetURL.searchParams.has(availabilityParameter) && !getShowAllPreference()) {
    targetURL.searchParams.set(availabilityParameter, '1');
    window.location.replace(targetURL.toString());
  }
})();
